import apiClient from './api';

export const shopifyService = {
  // Get Shopify connection status
  getStatus: async () => {
    const response = await apiClient.get('/api/shopify/status');
    return response.data;
  },

  // Connect Shopify store
  connect: async (storeUrl, apiKey) => {
    const response = await apiClient.post('/api/shopify/connect', {
      store_url: storeUrl,
      api_key: apiKey
    });
    return response.data;
  },

  // Disconnect Shopify store
  disconnect: async () => {
    const response = await apiClient.delete('/api/shopify/disconnect');
    return response.data;
  },

  // Trigger manual sync
  triggerSync: async () => {
    const response = await apiClient.post('/api/shopify/sync');
    return response.data;
  },

  // Get sync logs
  getSyncLogs: async () => {
    const response = await apiClient.get('/api/shopify/sync-logs');
    return response.data;
  },

  // Get mockup/demo data status
  getMockupStatus: async () => {
    const response = await apiClient.get('/api/shopify/mockup-status');
    return response.data;
  },

  // Clear mockup/demo data
  clearMockupData: async () => {
    const response = await apiClient.post('/api/shopify/clear-mockup-data');
    return response.data;
  }
};
